import { AtendimentoProfissional, Problema } from 'graphql/types.generated'
import { calcularIMC } from 'util/atendimento/calculateImc'
import { isEmpty } from 'util/validation/Util'

import { GANHO_PESO_VALORES_EIXO_X } from '../../components/modals/medicoes/graficos/pre-natal/ganho-peso/converter-graficoGanhoPeso'
import { categoriaImcReferenciaRecord } from '../../components/modals/medicoes/graficos/pre-natal/ganho-peso/model-graficoGanhoPeso'
import { getCategoriaImcReferencia } from '../../components/modals/medicoes/graficos/pre-natal/ganho-peso/util-graficoGanhoPeso'
import { MedicaoAntropometricaPreNatal } from '../../components/modals/medicoes/pre-natal/model-medicoesPreNatal'
import { MedicoesPreNatal } from '../../components/modals/types/model-historicoPreNatal'
import { convertMedicoesUltimaGestacao } from '../../soap/aside/pre-natal/converter-acompanhamentoPreNatal'
import { AcompanhamentoPreNatalQueryModel } from '../../soap/aside/pre-natal/model-acompanhamentoPreNatal'
import { CIAPS_GESTACAO_CODIGOS, CIDS_GESTACAO_CODIGOS } from '../../soap/pre-natal/model-preNatal'
import {
  MEDICOES_ACOMPANHAMENTO_PRE_NATAL,
  MedicoesAcompanhamentoPreNatal,
  PERCENTIS_POR_CATEGORIA,
} from './model-acompanhamentoPreNatal'

export const sortProblemasPreNatal = (a: Problema, b: Problema) => {
  const aIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(a.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(a.cid10?.codigo)
  const bIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(b.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(b.cid10?.codigo)

  if (aIsInPreNatal && !bIsInPreNatal) {
    return -1
  }

  if (!aIsInPreNatal && bIsInPreNatal) {
    return 1
  }

  return a.situacao.localeCompare(b.situacao)
}

export const getMedicoesPreNatal = (
  atendimentosProfUltimaGestacao: (AtendimentoProfissional | AcompanhamentoPreNatalQueryModel)[]
) => {
  return atendimentosProfUltimaGestacao?.map((atendProf, index) => {
    const medicao = !isEmpty(atendProf.medicoes) ? atendProf.medicoes[0] : null
    const dataMedicao = medicao?.dataMedicao ?? atendProf.iniciadoEm
    return convertMedicoesUltimaGestacao(index, medicao, atendProf.atendimentoProfissionalPreNatal, dataMedicao)
  })
}

export const convertToUltimasMedicoesRegistradas = (
  medicoesPreNatal: MedicoesPreNatal[]
): MedicoesAcompanhamentoPreNatal => {
  const ultimasMedicoesPreNatal: MedicoesAcompanhamentoPreNatal = {}

  const ordenadas = medicoesPreNatal?.sort((a, b) => b.numeroConsulta - a.numeroConsulta)

  MEDICOES_ACOMPANHAMENTO_PRE_NATAL.forEach((key) => {
    const campo = key as keyof MedicoesPreNatal
    const registroMaisRecente = ordenadas?.find((valor) => !isEmpty(valor[campo]))

    if (registroMaisRecente) {
      ultimasMedicoesPreNatal[campo] = {
        medicao: registroMaisRecente[campo],
        dataMedicao: registroMaisRecente.dataDaMedicao,
      }
    }
  })

  return ultimasMedicoesPreNatal
}

export const calculatePercentilPesoGestacional = (
  semanaAlvo: number,
  ganhoPeso: number,
  medicaoReferencia: MedicaoAntropometricaPreNatal
): string => {
  const imcReferencia = calcularIMC(medicaoReferencia?.peso, medicaoReferencia?.altura)
  const indiceSemana = GANHO_PESO_VALORES_EIXO_X.indexOf(semanaAlvo)

  const categoria = getCategoriaImcReferencia(imcReferencia)
  const labels = PERCENTIS_POR_CATEGORIA[categoria]

  const areasReferencia = categoriaImcReferenciaRecord[categoria].referenceAreas
  const linhasPercentis = areasReferencia.slice(1)

  const limitesSuperioresNaSemana = linhasPercentis.map((referencia) => referencia.area[indiceSemana]?.upperLimit)
  const indiceLinhaSuperior = limitesSuperioresNaSemana.findIndex((limiteY) => ganhoPeso <= (limiteY as number))

  if (indiceLinhaSuperior === -1) return labels.last()

  return labels[indiceLinhaSuperior]
}

export const removeVacinaPrefix = (name: string): string => {
  return name.replace(/^vacina\s+/i, '').trim()
}
